import { memo } from 'react';
import { useStaffTeams } from '../../hooks/useStaffTeams';
import { teamLabel, teamTone } from '../../utils/staffPlayer';
import { cn } from '../../utils/cn';

interface StaffTeamChipsProps {
  uuid: string | null | undefined;
  /** Rendered when the member is linked but on no team. */
  emptyLabel?: string | null;
  className?: string;
}

/** Tesseract team membership chips for a linked Minecraft account. */
export const StaffTeamChips = memo(({ uuid, emptyLabel = null, className }: StaffTeamChipsProps) => {
  const teams = useStaffTeams(uuid);
  if (!uuid) return null;
  if (teams.length === 0) {
    return emptyLabel ? <span className={cn('text-xs text-glass-500', className)}>{emptyLabel}</span> : null;
  }
  return (
    <span className={cn('inline-flex flex-wrap gap-1', className)}>
      {teams.map((team) => (
        <span key={team} className={cn('inline-flex items-center h-5 px-2 rounded-full text-[10px] font-semibold border whitespace-nowrap', teamTone(team))}>
          {teamLabel(team)}
        </span>
      ))}
    </span>
  );
});

StaffTeamChips.displayName = 'StaffTeamChips';
